/**
 * Share token API — the caller's share-credit token (backend = H-176).
 *
 * A share link carries `?share=<token>` so a recipient's first purchase earns
 * the sharer credit (processShareReward is already live server-side; the token
 * signing endpoint is delivered by H-176, running in parallel).
 *
 * Contract per the H-176 card: GET {CUSTOMER_API}/api/v1/share/token on the
 * canonical auth realm (mms-commerce) -> { token, url? }. When the backend
 * composes `url` it wins; otherwise the caller composes the canonical target
 * itself (D5: PDP mamamiya.store/products/:handle?share=<token>).
 */

import { CONFIG } from '../core/config.js'
import { apiRequest } from './index.js'

/**
 * Fetch (or mint, server-side idempotent) the current customer's share token.
 * Requires sign-in; throws on failure — callers degrade to a bare link.
 * @returns {Promise<{ token: string, url?: string|null }>}
 */
export async function fetchShareToken() {
  const data = await apiRequest(`${CONFIG.CUSTOMER_API}/api/v1/share/token`)
  return data?.data || {}
}

/**
 * Append the share token to a target URL, preserving any existing query.
 * @param {string} baseUrl
 * @param {string} token
 * @returns {string}
 */
export function buildShareUrl(baseUrl, token) {
  if (!token) return baseUrl
  const sep = baseUrl.includes('?') ? '&' : '?'
  return `${baseUrl}${sep}share=${encodeURIComponent(token)}`
}
